import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Container, TextField } from "@mui/material";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/Custom/CustomButton";
import useFormValidation from "../../components/Custom/FormValidation";
import { createCropValidationSchema } from "../../components/Custom/ValidationSchema";
import { createProgram } from "../../api/programs";

const validationSchema = createCropValidationSchema();

export default function CreateProgram() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const { errors, validate } = useFormValidation(formData, validationSchema);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validate({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    const program = await createProgram(formData.name);
    navigate(`/programs/program/${program.id}`);
  };

  return (
    <>
      <CustomAppBar title="Create Program" />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Add Program")}</CustomTitle>

            <TextField
              margin="normal"
              required
              fullWidth
              type="text"
              label={t("Program Name")}
              name="name"
              value={formData.name || ""}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              error={!!errors.name}
              helperText={errors.name}
            />
            <CustomButton onClick={handleSubmit}>{t("Save")}</CustomButton>
          </Grid>
        </div>
      </Container>
    </>
  );
}
